(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["compare-in-range"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.compare-in-range__product[data-href]').forEach(function (row) {
    var didSwipe = false;
    var startX = 0;
    var threshold = 10;

    row.addEventListener('touchstart', function (e) {
      didSwipe = false;
      startX = e.touches[0].clientX;
    }, { passive: true });

    row.addEventListener('touchmove', function (e) {
      if (Math.abs(e.touches[0].clientX - startX) > threshold) {
        didSwipe = true;
      }
    }, { passive: true });

    row.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      if (didSwipe) return;
      window.location.href = row.getAttribute('data-href');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
	const url = new URL(window.location.href);
	if (url.hash) {
		document.addEventListener(
			'DOMContentLoaded',
			() => {
				const card = document.getElementById(url.hash.slice(1));
				if (card) {
					card.scrollIntoView({ behavior: 'instant' });
				}
			},
			{ once: true }
		);
	}

  } catch(e) { console.error(e); }
})();
})();
